import { useContext } from 'react';

import { ConversionParamsContext } from '@/contexts';

const useConversionParams = () => {
  const ctx = useContext(ConversionParamsContext);

  if (!ctx) {
    throw new Error(
      'useConversionParams must be used within a ConversionParamsContext'
    );
  }

  return ctx;
};

export default useConversionParams;
